import React, { useState } from "react";
import Button from "../Button/Button";

import styles from "./Overlay.module.css";

// Function to save user
interface User {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  company: string;
}

interface ApiResponse {
  ok: boolean;
  error?: string;
  data?: any;
}

const Overlay = ({
  handleToggleOverlay,
}: {
  handleToggleOverlay: () => void;
}) => {
  const [token, setToken] = useState("");
  const [isTokenValid, setisTokenValid] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [company, setCompany] = useState("");
  const [status, setStatus] = useState("");
  const [message, setMessage] = useState("");

  const saveUser = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setMessage("A guardar...");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/users`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            firstName,
            lastName,
            email,
            phone,
            company,
            token,
          } as User),
        }
      );

      const result: ApiResponse = await response.json();
      if (response.ok) {
        setMessage("");
        setStatus("done");
        setFirstName("");
        setLastName("");
        setEmail("");
        setPhone("");
        setCompany("");
      } else {
        setMessage(result.error || "Erro desconhecido.");
      }
    } catch {
      setMessage("Falha no registo.");
    }
  };

  interface CheckTokenEvent extends React.FormEvent<HTMLFormElement> {}

  const checkToken = async (e: CheckTokenEvent) => {
    e.preventDefault();
    setMessage("");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/check-token`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            token,
          } as { token: string }),
        }
      );

      const result: { company: string; valid: boolean } = await response.json();
      if (response.ok) {
        if (result.valid) {
          setCompany(result.company);
          setisTokenValid(true);
        } else {
          setMessage("Código inválido.");
        }
      } else {
        setMessage("Código inválido.");
      }
    } catch {
      setMessage("Código inválido.");
    }
  };
  return (
    <div className={styles.overlay}>
      <div className={styles.box}>
        <button className={styles.closeButton} onClick={handleToggleOverlay}>
          <img src="/images/close.svg" alt="Close" />
        </button>
        {status === "done" ? (
          <>
            <img
              src="/images/success.svg"
              alt="sucesso"
              width={64}
              height={64}
            />
            <p className={styles.successText}>
              Registo efetuado com sucesso.
              <br />
              Em breve, irá receber um e-mail com toda a informação.
            </p>
          </>
        ) : isTokenValid ? (
          <form onSubmit={saveUser}>
            <input
              type="text"
              placeholder="Nome"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
            <input
              type="text"
              placeholder="Apelido"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
            />
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <input
              type="text"
              placeholder="Telefone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
            <Button
              label="Registar"
              type="primary"
              role="submit"
              disabled={status === "A guardar..."}
              small
            />
            <p className={styles.disclaimer}>
              Ao clicar “Registar” aceita os nossos <a href="/terms">termos</a>{" "}
              e <a href="/privacy">política de privacidade</a>.
            </p>
          </form>
        ) : (
          <form onSubmit={checkToken}>
            <div className={styles.quote}>
              <p>
                “ O mais importante na vida é que o mais importante seja o mais
                importante. „
              </p>
              <p>Stephen Covey</p>
            </div>
            <input
              type="text"
              placeholder="Inserir Código"
              onChange={(e) => setToken(e.target.value)}
              value={token}
              required
              style={{ textAlign: "center" }}
            />
            <Button label="Avançar" type="primary" role="submit" small />
          </form>
        )}
        {message && <p className={styles.message}>{message}</p>}
      </div>
    </div>
  );
};

export default Overlay;
